<div *ngIf="formGroup && placeInForm" xmlns="http://www.w3.org/1999/html">
  <section>
    <app-grid-registration-connection-info [model]="model"></app-grid-registration-connection-info>
    <h2>Angemeldete Speicheranlage</h2>

    <app-default-card
      [title]="'Netzanmeldung'"
      [info]="'Die hier angegebenen Informationen stammen aus Ihrer Netzanmeldung (Speicher)'">
      <!-- TODO: add storage-specific power summary fields as needed -->
      <form-row *ngIf="model.newProduction != null">
        <strong>Angemeldete Leistung (kVA):</strong>
        {{ model.newProduction | number : undefined : 'de-DE' }} kVA
      </form-row>
    </app-default-card>

    <app-default-card
      [title]="'Verbaute Komponenten'"
      [error]="componentsCardHasError"
      [errorMessage]="'Bitte überprüfen Sie die eingegebenen Daten.'"
      [info]="'Bitte geben Sie uns hier Informationen zu den tatsächlich verbauten Speicherkomponenten an.'">
      <section *ngIf="firstStorage">
        <h2>Speicher</h2>
        <app-storage-formpart-v2
          [storageForm]="firstStorage"
          [consumerForm]="firstConsumer ?? undefined"
          [producerForm]="firstProducer ?? undefined"></app-storage-formpart-v2>
        <mat-error *ngIf="firstConsumer?.errors?.powerExceeded || firstConsumer?.errors?.powerDeceeded">
          In Ihrer Inbetriebnahme haben Sie die Grenze entgegen der angemeldeten Bezugsleistung für Ihren
          Speicher {{ firstConsumer?.errors?.powerExceeded ? 'überschritten' : 'unterschritten' }}. Bitte
          nehmen Sie Kontakt zu uns auf um das weitere Vorgehen abzustimmen.
        </mat-error>
      </section>
      <section *ngIf="hasProduction$ | async">
        <h2>Wechselrichter</h2>
        <app-power-inverter-formpart
          [producerFormArray]="producers"
          [gridRegistration]="model"
          [disable]="false"></app-power-inverter-formpart>
      </section>
    </app-default-card>

    <app-default-card
      [title]="'Messkonzept'"
      [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
      [error]="!formGroup.get('meteringConcept').valid">
      <app-grid-registration-metering-concept-v2
        [disable]="false"
        [control]="meteringConcept"></app-grid-registration-metering-concept-v2>
      <form-row>
        <mat-error *ngIf="!meteringConcept.valid">Bitte wählen Sie ein Messkonzept aus.</mat-error>
      </form-row>
    </app-default-card>

    <app-default-card [title]="'Dokumente'" [info]="''">
      <app-upload-documents
        [inputFormArray]="uploads"
        [documentTag]="'uploads'"
        [showTag]="false"
        [canUpdate]="true"
        [filterCriteria]="'equal'"
        [numberOfUploads]="10"
        [editUpload]="true"
        [showUploadButton]="true">
        <div>
          <ng-container
            *ngIf="documentsUploadInfoUIAdaptionName | uiAdaptionVisible; else defaultTechnicalDocumentsInfo">
            <div [innerHTML]="documentsUploadInfoUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
          </ng-container>
          <ng-template #defaultTechnicalDocumentsInfo>
            <p>
              Relevante technische Dokumentationen.
              <br />
              z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
              Übersichtsschaltplan.
              <br />
            </p>
          </ng-template>
        </div>
      </app-upload-documents>
    </app-default-card>

    <app-gr-meter-formpart
      [formGroup]="formGroup"
      [hasDefiniteMeter]="model.feedingPlantType == FeedingPlantTypeEnum.Extension" />
  </section>

  <!-- TODO: Umbiegen 4105 / 4110 - Benötigte Felder ändern -->
  <app-default-card
    *ngIf="feederConnectionStandard !== FeederConnectionStandard.VDE4110"
    [title]="'VDE 4105 Checkliste'"
    [info]="''">
    <form [formGroup]="placeInForm" formFocusable>
      <section>
        <form-row>
          <mat-checkbox formControlName="effectiveAndRequestedValuesMatch">
            Übereinstimmung der Daten aus dem Antrag zur Netzanmeldung mit dem Anlagenaufbau?
            <mat-error
              *ngIf="
                !placeInForm.get('effectiveAndRequestedValuesMatch').valid &&
                placeInForm.get('effectiveAndRequestedValuesMatch').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="invoiceMeteringCheckDone">
            Abrechnungsmessung - Vorinbetriebsetzungsprüfung + Inbetriebsetzungsprüfung erfolgt?
            <mat-error
              *ngIf="
                !placeInForm.get('invoiceMeteringCheckDone').valid &&
                placeInForm.get('invoiceMeteringCheckDone').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="vdeCertificateExists">
            Einheitenzertifikat für Erzeugungseinheiten und/oder Speicher (soweit jeweils in der Kundenanlage
            verbaut) vorhanden (siehe Vordruck E.4) bzw. nach VDE-AR-N 4110?
            <mat-error
              *ngIf="
                !placeInForm.get('vdeCertificateExists').valid &&
                placeInForm.get('vdeCertificateExists').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="powerDirectionSensorCheckDone">
            Energieflussrichtungssensor - Funktionstest durch Errichter durchgeführt und bestanden?
            <mat-error
              *ngIf="
                !placeInForm.get('powerDirectionSensorCheckDone').valid &&
                placeInForm.get('powerDirectionSensorCheckDone').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <div class="group">
          <label id="regulator">
            Soweit im jeweiligen Anschlussfall erforderlich: Zertifikat für die Leistungsflussüberwachung am
            Netzanschlusspunkt (P
            <sub>AV, E</sub>
            - Überwachung, Symmetrieeinrichtung nach VDE-AR-N 4100, 5.5)?
            <mat-error
              *ngIf="
                !placeInForm.get('vdeArN4100_55_CertificateExists').valid &&
                placeInForm.get('vdeArN4100_55_CertificateExists').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </label>

          <form-row>
            <mat-radio-group
              aria-labelledby="regulator"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="vdeArN4100_55_CertificateExists">
              <mat-radio-button class="radio-button" [value]="true">Vorhanden</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="false">Nicht erforderlich</mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-checkbox formControlName="powerProtectionCertificateExists">
            Zertifikat für den NA-Schutz vorhanden (siehe Vordruck E.6)?
            <mat-error
              *ngIf="
                !placeInForm.get('powerProtectionCertificateExists').valid &&
                placeInForm.get('powerProtectionCertificateExists').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="factorCosphiCheck">
            Verfahren zur Blindleistungsbereitstellung:
            {{
              model.reactivePowerProvisioningMethod
                | appDisplayName : (this.metaService.reactivePowerProvisioningMethods$ | async)
            }}
            eingestellt?
            <mat-error
              *ngIf="
                !placeInForm.get('factorCosphiCheck').valid && placeInForm.get('factorCosphiCheck').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
        <app-hint-card
          [outlined]="true"
          [type]="'warning'"
          *ngIf="
            'gridRegistration.placeInServiceRequest.vdeChecklistFactorCosphiCheckHint'
              | uiAdaptionVisible$
              | async
          ">
          <div
            [innerHTML]="
              'gridRegistration.placeInServiceRequest.vdeChecklistFactorCosphiCheckHint'
                | uiAdaptionValue
                | safeHtmlPipe
            "></div>
        </app-hint-card>
      </section>
      <section>
        <h2>NA-Schutz</h2>
        <div class="group">
          <form-row>
            <label id="naProtection">Art des NA-Schutzes:</label>
            <mat-error
              *ngIf="!placeInForm.get('naProtection').valid && placeInForm.get('naProtection').touched">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="naProtection"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="naProtection"
              (change)="setValidatorsNaProtection()">
              <mat-radio-button class="radio-button" [value]="naProtectionTypeEnum.Integrated">
                Integriert
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="naProtectionTypeEnum.Centralised">
                Zentral
              </mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Eingestellter Wert des Spannungssteigerungsschutz in V</mat-label>
            <input matInput type="number" formControlName="overvoltageProtectionType" />
          </mat-form-field>
        </form-row>

        <div
          *ngIf="
            placeInForm.get('naProtection') &&
            placeInForm.get('naProtection').value == naProtectionTypeEnum.Centralised
          ">
          <form-row>
            <mat-checkbox formControlName="overvoltageReleaseTestDone">
              Auslösetest "Zentraler NA-Schutz - Kuppelschalter" erfolgreich durchgeführt?
              <mat-error
                *ngIf="
                  !placeInForm.get('overvoltageReleaseTestDone').valid &&
                  placeInForm.get('overvoltageReleaseTestDone').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
          <form-row>
            <mat-checkbox formControlName="triggerCircuitTestDone">
              Auslösekreises "Zentraler NA-Schutz - Kuppelschalter" nach Ruhestromprinzip ausgeführt und
              geprüft?
              <mat-error
                *ngIf="
                  !placeInForm.get('triggerCircuitTestDone').valid &&
                  placeInForm.get('triggerCircuitTestDone').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
        </div>
      </section>
      <section>
        <h2>
          P
          <sub>AV, E</sub>
          - Überwachung
        </h2>
        <div class="group">
          <form-row>
            <label id="pMonitoringExists">
              P
              <sub>AV, E</sub>
              - Überwachung vorhanden:
            </label>
            <mat-error
              *ngIf="
                !placeInForm.get('pMonitoringExists').valid && placeInForm.get('pMonitoringExists').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="pMonitoringExists"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="pMonitoringExists"
              (change)="setValidatorsMonitoring()">
              <mat-radio-button class="radio-button" [value]="true">Ja</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="false">Nein</mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>
              Eingestellte Wirkleistung P
              <sub>AV,E</sub>
              in kW
            </mat-label>
            <input matInput type="number" formControlName="effectivePave" />
          </mat-form-field>
        </form-row>

        <form-row
          *ngIf="placeInForm.get('pMonitoringExists') && placeInForm.get('pMonitoringExists').value == true">
          <mat-checkbox formControlName="paveTestDone">
            Funktionstest P
            <sub>AV,E</sub>
            - Überwachung erfolgreich durchgeführt?
            <mat-error
              *ngIf="!placeInForm.get('paveTestDone').valid && placeInForm.get('paveTestDone').touched">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
      </section>
      <section>
        <h2>Symmetriebedingung</h2>

        <div class="group">
          <form-row>
            <label id="symmetryConditions">Die Symmetriebedingung wird eingehalten...</label>
            <mat-error
              *ngIf="
                !placeInForm.get('symmetryConditions').valid && placeInForm.get('symmetryConditions').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="symmetryConditions"
              class="radio-group radio-group--vertical"
              fxLayoutGap="2em"
              formControlName="symmetryConditions"
              (change)="setSymmetryConditionsMonitoring()">
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.ThreePhase">
                durch einen Drehstromgenerator oder einen dreiphasigen Umrichter.
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.DeviceBalancing">
                durch eine Symmetrieeinrichtung, die den Unsymmetriewert auf 4,6kVA je Außenleiter begrenzt.
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.SinglePhaseDistribution">
                durch folgende Aufteilung der einphasig angeschlossenen Erzeugungseinheiten je Außenleiter.
              </mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <div
          class="group"
          *ngIf="
            placeInForm.get('symmetryConditions') &&
            placeInForm.get('symmetryConditions').value == symmetryConditionsEnum.SinglePhaseDistribution
          ">
          <div class="group">
            <h4>
              Summe S
              <sub>Emax</sub>
              &nbsp;der neu hinzukommenden Erzeugungsanlagen/Speicher *
            </h4>
            <form-row>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L1 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL1" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL1').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L2 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL2" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL2').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L3 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL3" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL3').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
            </form-row>
          </div>

          <div class="group">
            <h4>
              Summe S
              <sub>Emax</sub>
              &nbsp;der ggf. vorhandenen Erzeugungsanlagen/Speicher
            </h4>
            <form-row>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L1 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL1" />
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L2 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL2" />
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L3 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL3" />
                </mat-form-field>
              </div>
            </form-row>
          </div>
        </div>
      </section>
      <section>
        <h2>Datum der EEG-Technischen Inbetriebnahme</h2>
        <form-row>
          <mat-form-field appearance="outline">
            <mat-label>Datum der Inbetriebnahme</mat-label>
            <input matInput formControlName="placeInServiceDatum" [matDatepicker]="placeInServiceDatum" />
            <mat-datepicker-toggle matSuffix [for]="placeInServiceDatum"></mat-datepicker-toggle>
            <mat-datepicker #placeInServiceDatum></mat-datepicker>
            <mat-error
              *ngIf="
                !placeInForm.get('placeInServiceDatum').valid &&
                placeInForm.get('placeInServiceDatum').touched
              ">
              {{ errorFieldRequired }}
            </mat-error>
          </mat-form-field>
        </form-row>
      </section>
      <section>
        <h2>Vollmacht</h2>
        <form-row>
          <mat-checkbox formControlName="customerAuthorization">
            Eine Vollmacht des Kunden liegt vor.
          </mat-checkbox>
        </form-row>
      </section>
      <section>
        <h2>Abschluss</h2>
        <form-row>
          <mat-checkbox formControlName="vdeConditions">
            Die Erzeugungsanlage und/oder der Speicher ist/sind nach VDE-AR-N 4105, VDE-AR-N 4100 und den
            technischen Anschlussbedingungen des Netzbetreibers errichtet.
            <br />
            Der Anlagenerrichter hat den Anlagenbetreiber einzuweisen und eine vollständige Dokumentation
            inkl. Schaltplan nach den jeweils gültigen VDE-Bestimmungen zu übergeben.
            <mat-error
              *ngIf="!placeInForm.get('vdeConditions').valid && placeInForm.get('vdeConditions').touched">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
      </section>
    </form>
  </app-default-card>
</div>

<section>
  <mat-error *ngIf="errorFormList && errorFormList.length > 0" class="wrapper" style="text-align: right">
    <strong>Bitte beheben Sie die Fehler im Formular</strong>
  </mat-error>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">
      Inbetriebsetzungsprotokoll absenden
    </button>
  </div>
</section>
